module.exports = __webpack_public_path__ + "static/img/solution-banner-title.25b30df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-banner-title.png
// module id = bzZs
// module chunks = 0